// extracted by mini-css-extract-plugin
module.exports = {"popoverInnerContent":"ServiceColumns_popoverInnerContent__rv9HJ","divider":"ServiceColumns_divider__cTnx7","col":"ServiceColumns_col__zGGou"};